// extracted by mini-css-extract-plugin
module.exports = {"Loading":"mx_a pz_a pz_w pz_j pz_px pz_py pz_fa"};